import { usePromotePageState } from 'src/app/pages/promote/pageContext';

type Result = ModelHookResult<{
	displayed: boolean;
}>;

export function useGeneralErrorMessage(): Result {
	const [{ formState }] = usePromotePageState();

	return {
		data: {
			displayed: formState.status === 'error',
		},
	};
}
